// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1J-BbG","iconContainer":"ImFfXz","iconContainerVisited":"_6a9JB-","icon":"_2-27EE","preTitle":"_3Dz6ij"};